import { CrewServiceMock } from "@/orders/services/crew/crew.types";

export const mockCrewService = (): CrewServiceMock => ({
  fetchByIdentify: jest.fn(),
  fetchByLicense: jest.fn(),
  fetchByOrder: jest.fn(),
});
